import SwitchAccount from "./SwitchAccount";

export default SwitchAccount